import {docCallAccptNumber, docCallNumber, getCallNumberList} from "@/api";
import {message, getTodayDate, messageHtml} from "../../utils/common";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                schDate: getTodayDate(),
                reStatus: null,
            },
            tableLoading: false,
            tableData: [],
            dateTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        },1000)
    },
    created() {
        this.getCallNumberListInfo();
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.schDate = "";
            this.queryParams.reStatus = null;
            this.getCallNumberListInfo();
        },


        // 选择叫号状态
        chooseStatus() {
            this.currentPage = 1;
            this.getCallNumberListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getCallNumberListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getCallNumberListInfo();
        },


        // 查询叫号列表
        getCallNumberListInfo: function () {
            this.tableData = [];
            this.tableLoading = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                schDate: this.queryParams.schDate,
                reStatus: this.queryParams.reStatus,
            };
            getCallNumberList(data).then(res => {
                console.log("getCallNumberListInfo >>>> " + JSON.stringify(res));
                const rdata = res.data;
                console.log(rdata);
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = new Date(item.cardPatientBirth).getFullYear();
                        let nowYear = new Date().getFullYear();
                        item.age = parseInt(nowYear - birYear);
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '5'?'待就诊':item.reStatus === '6'?'就诊中':'已过号';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                message(error, "error");
            });
        },

        // 叫号
        calling(row) {
            // console.log(row);
            let cardPatientName = row.cardPatientName;
            docCallNumber(cardPatientName).then(res => {
                console.log(res);
                if (res.code === 200) {
                    messageHtml("正在呼叫 <span class='font_orange font_18 mrlr10'>"+cardPatientName+"</span> 前往诊室就诊", "success");
                }
            });
        },


        // 接诊
        callToOrder(row) {
            // console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            let reId = row.reId;
            console.log(reId)
            docCallAccptNumber(reId).then(res => {
                console.log(res);
                if (res.code === 200) {
                    this.isOpenCallNumber = false;
                    // 叫号成功后，跳到接诊页面
                    window.sessionStorage.removeItem("reservationPatient");
                    window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));

                    this.$router.push({path: '/admin/clinictreat'});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                }
            });
        },

    }
}
